import { combineReducers } from 'redux';
import { loadingReducer } from './loading/loading-reducer';
const reducers = {
  loading: loadingReducer,
};

export default combineReducers(reducers);
